import { Property } from "../../events/Property";
import { UIComponent } from "../components/UIComponent";
import { GraphicalElement } from "../graphical/GraphicalElement";

export class UIProperty<T> extends Property<T>
{
  #graphicalElement:GraphicalElement;
  get graphicalElement(){ return this.#graphicalElement }

  constructor( component:GraphicalElement, value:T )
  {
    super( value );
    this.#graphicalElement = component;
    this.#graphicalElement._addProperty( this );
  }
}

interface Comparable<T>
{
  equals( other:T ):boolean
}

export class ComparableUIProperty<T extends Comparable<T> > extends UIProperty<T>
{ 
  isEqual( a:T, b:T )
  {
    let valueA = a === null ? 0 : a === undefined ? 1 : 2;
    let valueB = b === null ? 0 : b === undefined ? 1 : 2;

    if ( valueA !== valueB )
    {
      return false;
    }

    if ( valueA !== 2 )
    {      
      return true;
    }    

    return a.equals( b );
  }
}